<template>
  <section id="checkboxes">
     <div class="demo">
      <div class="row">
        <div class="col-lg-6">
          <h5>
            Basic
          </h5>
          <p>
            Supports bootstrap brand colors:
            <code>.checkbox-primary</code>
            etc.
          </p>
          <!-- <div class="checkbox"> <input id="checkbox0" type="checkbox"> <label for="checkbox0"> Simple </label> </div> -->
          <div class="checkbox checkbox-default">
            <input id="checkbox1" type="checkbox">
            <label for="checkbox1">
              Default
            </label>
          </div>
          <div class="checkbox checkbox-primary">
            <input id="checkbox2" type="checkbox" checked="">
            <label for="checkbox2">
              Primary
            </label>
          </div>
          <div class="checkbox checkbox-danger">
            <input id="checkbox6" type="checkbox" checked="">
            <label for="checkbox6">
              Check me out
            </label>
          </div>

        </div>
        <div class="col-lg-6">
          <h5>
            Disabled
          </h5>
          <p>
            Disabled state also supported.
          </p>
          <div class="checkbox">
            <input id="checkbox9" type="checkbox" disabled="disabled"/>
            <label for="checkbox9">
              Can't check this
            </label>
          </div>
          <div class="checkbox checkbox-primary">
            <input id="checkbox10" type="checkbox" disabled="" checked=""/>
            <label for="checkbox10">
              This too
            </label>
          </div>
          <div class="checkbox checkbox-danger">
            <input id="checkbox11" type="checkbox" disabled="" checked=""/>
            <label for="checkbox11">
              And this
            </label>
          </div>
        </div>
      </div>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/forms/checkboxes.md";
export default {
  name: "checkboxes",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.form.checkboxes.name);
    this.$emit("update-tagline", this.$root.yamlData.form.checkboxes.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
